/*eslint-disable */

declare global {
    interface Window {
        clarity: any;
    }
}

function init(c: Window & typeof globalThis, l: Document, a: "clarity", r: string, i: string, t?: any, y?: any) {
    c[a] = c[a] || function() { (c[a].q = c[a].q || []).push(arguments) }
    t = l.createElement(r)
    t.async = 1
    t.src = "https://www.clarity.ms/tag/" + i
    y = l.getElementsByTagName(r)[0]
    y.parentNode.insertBefore(t, y)
}

export function initClarity(id: string) {
    init(window, document, "clarity", "script", id)
}


